import type { TranslationMessages } from '../../types';

export const points: TranslationMessages = {
  title: 'Điểm',
  current_balance: 'Số dư hiện tại',
  points_history: 'Lịch sử điểm',
  transaction_type: 'Loại giao dịch',
  earned: 'Kiếm được',
  spent: 'Đã chi tiêu',
  bonus: 'Thưởng',
  penalty: 'Phạt',
  redemption: 'Đổi thưởng',
  adjustment: 'Điều chỉnh',
  reason: 'Lý do',
  description: 'Mô tả',
  amount: 'Số tiền',
  date: 'Ngày',
  filter_by_reason: 'Lọc theo lý do',
  all_reasons: 'Tất cả lý do',
  checklist_completion: 'Hoàn thành danh sách kiểm tra',
  perfect_attendance: 'Điểm danh hoàn hảo',
  customer_compliment: 'Khen ngợi của khách hàng',
  badge_achievement: 'Thành tích huy hiệu',
  above_and_beyond: 'Vượt trên mong đợi',
  teamwork: 'Làm việc nhóm',
  missing_checklist: 'Thiếu danh sách kiểm tra',
  late_arrival: 'Đến muộn',
  customer_complaint: 'Khiếu nại của khách hàng',
  policy_violation: 'Vi phạm chính sách',
  no_show: 'Không đến',
  early_leave: 'Về sớm',
};
